import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message, Modal} from 'antd';
import {Route, Switch} from "react-router-dom";
import Create from './create';
import {
  createResource,
  deleteResource,
  fetchResource,
  getLocationByQuery,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  updateResource,
} from "../../appRedux/actions/JobCardAllocation";

import {searchManpower} from "../../appRedux/actions/Manpower";
import {fetchFilter} from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import ListCard from "../../components/ListCard";
import moment from "moment";
import * as _ from 'lodash';

export class JobCardAllocation extends Component {
  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {
      // 'createdAt': JSON.stringify({value: moment(Date.now()), type: 'Date', field: 'createdAt'})
    },
    location: '',
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    selectedDate: moment(Date.now()),
    query: this.initialQueryState,
    columns: [],
    visibleColumns: [],
    visible: false,
    paramsId: '',
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.getLocationByQuery();
    this.props.fetchFilter(this.props.resourceName);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({visibleColumns: columns}, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleSelectLocation = (location) => {
    const query = {...this.props.query};
    if (!query.filters) {
      query.filters = {};
    }
    query.location = location;
    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleSelectDate = (date) => {
    this.setState({selectedDate: date});
    const query = {...this.props.query};
    if (!query.filters) {
      query.filters = {};
    }
    // query.filters['createdAt'] = JSON.stringify({
    //   value: date,
    //   type: 'Date',
    //   field: 'createdAt'
    // });
    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  showModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      visible: true,
    });
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  showForm = () => {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName, manpower, allLocation} = this.props;
    const {columns, visibleColumns, visible, selectedDate} = this.state;
    faviconDynamicFunction(authUser);
    return <Modal
      title="Job Card Allocation"
      visible={this.state && this.state.visible}
      onOk={this.handleOk}
      onCancel={this.handleCancel}
      footer={null}
    >
      {
        visible ? <Create data={edit}
                          paramsId={this.state && this.state.paramsId}
                          filters={filters}
                          modules={modules}
                          title={'EDIT'}
                          selectedDate={selectedDate}
                          resource={resourceName}
                          searchManpower={this.searchManpower}
                          fetch={fetchResource}
                          onChange={this.handleFormChange}
                          onSubmit={this.updateResource}
                          loading={loading}
                          manpower={manpower}
        /> : null
      }
    </Modal>
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;

    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return;
      }

      if (item === 'allocate') {
        return columns.push({
          title: sanitizeFieldName(item),
          dataIndex: filters[item].field,
          sorter: true,
          render: (value) => {
            const manpower = value.filter(item => moment(item && item.date).format('YYYY-MM-DD') === moment(this.state && this.state.selectedDate).format('YYYY-MM-DD'));
            const dataValue = manpower.length ? [{ name: manpower[0].manpower.name }] : [];
            return getRenderForFieldByType(dataValue, filters[item].type, item)
          },
          ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
        })
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => {
        return <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>Allocate</Button>
          }}/>

          {/*<AccessControl resource={this.props.resourceName} permissionNeeded={'d'}*/}
          {/*               roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {*/}
          {/*  return <Popconfirm*/}
          {/*    title="Are you sure you want to delete this record?"*/}
          {/*    onConfirm={() => {*/}
          {/*      this.deleteResource(record._id)*/}
          {/*    }}*/}
          {/*    onCancel={this.cancelDelete}*/}
          {/*    okText="Yes"*/}
          {/*    cancelText="No"*/}
          {/*  >*/}
          {/*    <Button style={{marginLeft: '10px'}} type="danger" size='small'>Delete</Button>*/}
          {/*  </Popconfirm>*/}
          {/*}}/>*/}

        </div>
      },
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    })
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  updateResource = (values, id) => {
    const { selectedDate } = this.state;
    values.date = selectedDate;
    this.props.updateResource(values, id);
    this.setState({ visible: false });
  };

  deleteResource = (id) => {
    this.props.deleteResource(id);
  };

  cancelDelete = () => {
    message.error('Cancelled')
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = (id) => {
    this.props.fetchResource(id);
    this.setState({ visible: true, paramsId: id });
    // const {match} = this.props;
    // this.props.history.push(`${match.url}/edit/${id}`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "JobCardAllocation");
  }

  searchManpower = (id) => {
    this.props.searchManpower(id);
  };

  getLocationByQuery = (location) => {
    this.props.getLocationByQuery(location);
  };

  render() {
    const {match, data, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName, manpower, allLocation} = this.props;
    const {columns, visibleColumns} = this.state;

    return (<div>
      <h2>{'Job Card Allocation'}</h2>
      {this.showForm()}

      <Switch>
        <Route path={`${match.url}`} exact
               render={() => <ListCard columns={columns}
                                       visibleColumn={visibleColumns}
                                       data={data}
                                       clearFilter={this.clearAll}
                                       selectDate={this.handleSelectDate}
                                       selectLocation={this.handleSelectLocation}
                                       selectedDate={this.state.selectedDate}
                                       filters={filters}
                                       allLocation={allLocation}
                                       handleChange={this.handleChange}
                                       columnChange={this.handleColumnChange}
                                       downloadToCSV={this.downloadToCSV}
                                       title={resourceName}
                                       size={'middle'}
                                       create={this.create}
                                       pagination={this.props.query.pagination}
                                       loading={loading}
                                       authUser={authUser}
                                       selectJobCard={this.edit}
               />
               }/>
        <Route path={`${match.url}/add`}
               render={(props) => <Create data={{}}
                                          filters={filters}
                                          modules={modules}
                                          title={'CREATE'}
                                          resource={resourceName}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.createResource}
                                          loading={loading}
                                          {...props}
               />
               }/>
        <Route path={`${match.url}/edit/:id`}
               render={(props) => <Create data={edit}
                                          filters={filters}
                                          modules={modules}
                                          title={'EDIT'}
                                          resource={resourceName}
                                          searchManpower={this.searchManpower}
                                          fetch={fetchResource}
                                          onChange={this.handleFormChange}
                                          onSubmit={this.updateResource}
                                          loading={loading}
                                          manpower={manpower}
                                          {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({auth, jobCardAllocation, manpower, commonData}) => {
  return {
    authUser: auth.authUser,
    total: jobCardAllocation.total,
    data: jobCardAllocation.resources,
    resource: jobCardAllocation.resource,
    edit: jobCardAllocation.edit,
    query: jobCardAllocation.query,
    allLocation: jobCardAllocation.location,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    manpower: manpower.manpowerList,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    searchManpower,
    getLocationByQuery,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(JobCardAllocation);
